<template>
    <div class="wisdom greybg">
        GIVE YOUR MONEY TO US<br/>
        <a :class="btnClass" @click="see">SEE WHY</a>

        <div :class="explClass">
            Why, you ask?<br/>
            <br/>
            Look.<br/>
            We <strong>NEED</strong> money.<br/>
            You <strong>HAVE</strong> money.<br/>
            So, you <strong>give your money to us</strong>! It's simple like that.
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            open: false
        };
    },

    methods: {
        see() {
            this.open = true;
        }
    },

    computed: {
        explClass() {
            return this.open ? "explanation" : "explanation hidden";
        },

        btnClass() {
            return this.open ? "btn hidden" : "btn";
        }
    }
}
</script>

<style scoped>

a {
    color: #fff;
    text-decoration: none;
    font-size: 14pt;
    cursor: pointer;
}

.explanation {
    font-size: 0.5em;
    color: #ff00ff;
}

.btn {
    border: 1px solid #ff00ff;
    padding: 1em 0.5em;
    display: inline-block;
}

.btn:hover {
    background: #ff00ff;
}

@media (max-width: 640px) {
    .explanation {
        font-size: 12pt;
    }
}

.hidden {
    display: none;
}

</style>



// WEBPACK FOOTER //
// src/components/Money.vue